export default {"src":"/_next/static/media/PlowerIcon.33fc6c9f.svg","height":70,"width":183};